import React, { useEffect, useRef } from "react";

const ArrowIcon = () => (
  <svg fill="none" strokeWidth="2" viewBox="0 0 24 24">
    <path d="M7 17L17 7M7 7h10v10" />
  </svg>
);

const portfolioItems = [
  {
    title: "Citi Bike Data 2",
    label: "Personal Project",
    href: "https://app.citibikedata.com",
    imgSrc: "/portfolio/cb-2.jpg",
  },
  {
    title: "Bus Blockers",
    label: "Personal Project",
    href: "https://busblockers.patrickcleary.com",
    imgSrc: "/portfolio/bb-2.jpg",
  },
  {
    title: "Citi Bike Data",
    label: "Personal Project",
    href: "https://citibikedata.com",
    imgSrc: "/portfolio/cb.jpg",
  },
  {
    title: "NYC Parking Regulations",
    label: "WXY Studio",
    labelHref: "https://www.wxystudio.com",
    href: "https://parkingregulations.nyc",
    imgSrc: "/portfolio/nycpr.jpg",
  },
  {
    title: "Blue Bike Data",
    label: "Personal Project",
    href: "https://bluebikedata.com",
    imgSrc: "/portfolio/bb.jpg",
  },
  {
    title: "Civic Atlas",
    label: "Civic Atlas",
    labelHref: "https://www.civicatlas.net",
    href: "https://www.civicatlas.net",
    imgSrc: "/portfolio/ca.jpg",
  },
  {
    title: "Humanity Land",
    label: "WXY Studio",
    labelHref: "https://www.wxystudio.com/projects/humanity_land/",
    href: "https://humanity.land",
    imgSrc: "/portfolio/hl.jpg",
  },
  {
    title: "MBTA Performance Dashboard",
    label: "TransitMatters",
    labelHref: "https://transitmatters.org",
    href: "https://dashboard.transitmatters.org",
    imgSrc: "/portfolio/tm.jpg",
  },
  {
    title: "D.C. Schools Explorer",
    label: "WXY Studio",
    labelHref: "https://www.wxystudio.com",
    href: "https://www.dcschoolboundaryexplorer.com/map?mode=edit",
    imgSrc: "/portfolio/dc.jpg",
  },
];

export const Portfolio = () => {
  const headerRef = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<(HTMLAnchorElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) =>
          e.target.classList.toggle("visible", e.isIntersecting)
        ),
      { threshold: 0.1 }
    );
    if (headerRef.current) observer.observe(headerRef.current);
    itemRefs.current.forEach((r) => r && observer.observe(r));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="portfolio" className="portfolio-section">
      <div className="portfolio-header reveal" ref={headerRef}>
        <h2>Work</h2>
        <span className="portfolio-count">
          0{portfolioItems.length} projects
        </span>
      </div>
      <div className="portfolio-grid">
        {portfolioItems.map((item, i) => (
          <a
            key={item.title}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className="portfolio-item reveal"
            ref={(el) => {
              itemRefs.current[i] = el;
            }}
            style={{ transitionDelay: `${i * 0.05}s` }}
          >
            <img className="portfolio-img" src={item.imgSrc} alt={item.title} />
            <div className="portfolio-overlay">
              <div className="portfolio-item-info">
                <span className="portfolio-item-name">{item.title}</span>
                {item.labelHref ? (
                  <a
                    className="portfolio-item-label"
                    href={item.labelHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {item.label}
                  </a>
                ) : (
                  <span className="portfolio-item-label">{item.label}</span>
                )}
              </div>
            </div>
            <div className="portfolio-link-icon">
              <ArrowIcon />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};
